import { Observable, of } from "rxjs";
import { LogEntry } from "./log-entry";
import { Logger } from "./logger";
import { LogTypeEnum } from "../enums/log-enum";

export class LoggerConsole extends Logger {
  log(entry: LogEntry): Observable<boolean> {
    // Log to console using the appropriate method based on log level
    const logMessage = entry.buildLogString();
    
    switch (entry.level) {
      case LogTypeEnum.DEBUG:
        console.debug(logMessage);
        break;
      case LogTypeEnum.INFO:
        console.info(logMessage);
        break;
      case LogTypeEnum.WARN:
        console.warn(logMessage);
        break;
      case LogTypeEnum.ERROR:
        console.error(logMessage);
        break;
      case LogTypeEnum.FATAL:
        console.error(logMessage);
        break;
      case LogTypeEnum.ALL:
      default:
        console.log(logMessage);
        break;
    }
    
    return of(true);
  }

  clear(): Observable<boolean> {
    console.clear();
    return of(true);
  }
}
